import {ERROR_WAIT_BLOCK, STEP_WAIT_BLOCK, handleSessionExpired} from "../../AdminProtectora/actions/actionsAdmin";
export const ERROR_INSERT_ANIMAL = 'ERROR_INSERT_ANIMAL';
export const LOAD_ANIMAL_DETAIL = 'LOAD_ANIMAL_DETAIL';
export const LOAD_ANIMAL_DETAIL_PROTECTORA = "LOAD_ANIMAL_DETAIL_PROTECTORA";
export const RESET_ANIMAL_DETAIL = 'RESET_ANIMAL_DETAIL';


export function loadInfoAnimalDetail(id, animalControl) {
    return (dispatch, getState) => {
        //console.log("actionsAnimalList::loadInfoAnimalDetail()");
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: {
                tipo: "completa"
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/animal/" + id,
        })
            .done(function (response, textStatus, jqXHR) {
                // console.log(response);
                if (animalControl === "animals") {
                    dispatch({type: LOAD_ANIMAL_DETAIL, payload: {infoAnimalDetail: response}});
                } else if (animalControl === "animalsProtectora") {
                    dispatch({type: LOAD_ANIMAL_DETAIL_PROTECTORA, payload: {infoAnimalDetail: response}});
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
                if (animalControl === "animals") {
                    dispatch({type: LOAD_ANIMAL_DETAIL, payload: {infoAnimalDetail: {error: true}}});
                } else if (animalControl === "animalsProtectora") {
                    dispatch({type: LOAD_ANIMAL_DETAIL_PROTECTORA, payload: {infoAnimalDetail: {error: true}}});
                }
            });
    }
}

export function resetAnimalDetail() {
    //console.log("****  actionsAnimalList::resetAnimalDetail()");
    return (dispatch, getState) => {
        dispatch({type: RESET_ANIMAL_DETAIL, payload: {}});
    }
}

export function resetInfoAnimalDetail(animalControl) {
    //console.log("actionsAnimalList::resetInfoAnimalDetail() -> animalControl = '" + animalControl + "'");
    return (dispatch, getState) => {
        if (animalControl === "animals") {
            dispatch({type: LOAD_ANIMAL_DETAIL, payload: {infoAnimalDetail: {}}});
        } else if (animalControl === "animalsProtectora") {
            dispatch({type: LOAD_ANIMAL_DETAIL_PROTECTORA, payload: {infoAnimalDetail: {}}});
        }
    }
}


export function changeEspecieInfoAnimalDetail(especie, animalControl) {
    return (dispatch, getState) => {
        if (animalControl === "animals") {
            let _infoAnimalDetail = getState().animalDetail.infoAnimalDetail;
            _infoAnimalDetail.especie = especie;
            dispatch({type: LOAD_ANIMAL_DETAIL, payload: {infoAnimalDetail: _infoAnimalDetail}});
        } else if (animalControl === "animalsProtectora") {
            let _infoAnimalDetail = getState().animalDetailProtectora.infoAnimalDetail;
            _infoAnimalDetail.especie = especie;
            dispatch({type: LOAD_ANIMAL_DETAIL_PROTECTORA, payload: {infoAnimalDetail: _infoAnimalDetail}});
        }
    }
}

export function changeAnimalDetail(animalDetail, access) {
    return (dispatch, _getState) => {
        
        let datos = parserBasicData(animalDetail);
        let datos_base64 = btoa(access.user + ":" + access.password);
        $.ajax({
                type: "PUT",
                data: JSON.stringify(datos),
                dataType: "json",
                contentType: "application/json",
                url: "/api/animal/" + datos.id,
                beforeSend: function (req) {
                    req.setRequestHeader("Authorization", "Basic " + datos_base64);
                }
            })
            .done(function (_response, _textStatus, _jqXHR) {
                dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: undefined}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 2}});
            })
            .fail(function ({responseJSON, status}, _textStatus, _errorThrown) {
                let errorStr;
                if (typeof responseJSON === "object" && responseJSON.error !== undefined) {
                    errorStr = responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = responseJSON ? responseJSON : "Hubo un error inesperado al guardar los datos :(";
                }
                if (status === 401) {
                    handleSessionExpired(dispatch, {responseJSON, status}, _textStatus, _errorThrown)
                }
                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
                dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
                dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: errorStr}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: status}});
            });
    }
}

export function insertAnimalDetail(animalDetail, access) {
    return (dispatch, _getState) => {
        let datos = parserBasicData(animalDetail);
        let datos_base64 = btoa(access.user + ":" + access.password);
        $.ajax({
                type: "POST",
                data: JSON.stringify(datos),
                dataType: "json",
                contentType: "application/json",
                url: "/api/animal",
                beforeSend: function (req) {
                    req.setRequestHeader("Authorization", "Basic " + datos_base64);
                }
            })
            .done(function (response, textStatus, jqXHR) {
                dispatch({
                    type: LOAD_ANIMAL_DETAIL_PROTECTORA, payload: {
                        infoAnimalDetail: {
                            ...animalDetail,
                            ...response
                        }
                    }
                });
                dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: undefined}});
                dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: undefined}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 2}});
            })
            .fail(function ({responseJSON, status}, textStatus, _errorThrown) {
                let errorStr;
                if (typeof responseJSON === "object" && responseJSON.error !== undefined) {
                    errorStr = responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = responseJSON;
                }
                if (status === 401) {
                    handleSessionExpired(dispatch, {responseJSON, status}, textStatus, _errorThrown)
                }
                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
                dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
                dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: errorStr}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: status}});
            });
    }
}

export function sendMainImageAnimal(info, infoAccess) {
    return (dispatch) => {
        let datos_base64 = btoa(infoAccess.user + ":" + infoAccess.password);
        if (info && info.img_principal) {
            info.img_principal.data = null
        }
        if (info && info.img_principal && info.img_principal.isModified) {
            
            $.ajax({
                    type: "PUT",
                    dataType: "json",
                    contentType: "application/json",
                    processData: false,
                    cache: false,
                    crossDomain: true,
                    beforeSend: function (req) {
                        req.setRequestHeader("Authorization", "Basic " + datos_base64);
                    },
                    url: `/api/animal/${info._id}/imagen`,
                    data: JSON.stringify({imageData: info.img_principal}),
                })
                .done(function (_response, _textStatus, _jqXHR) {
                    dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: undefined}});
                    dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: undefined}});
                    dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 3}});
                })
                .fail(function (jqXHR, textStatus, _errorThrown) {
                    let errorStr;
                    if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                        errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                        
                    } else if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.message !== undefined) {
                        errorStr = "Hubo un error inesperado al guardar la imagen del animal";
                    } else {
                        errorStr = jqXHR.responseJSON;
                    }
                    if (jqXHR.status === 413) {
                        errorStr = 'La imagen principal pesa demasiado, máximo 6MB por imagen';
                    }
                    if (jqXHR.status === 401) {
                        handleSessionExpired(dispatch, jqXHR, textStatus, _errorThrown)
                    }
                    errorStr = errorStr || _errorThrown;
                    
                    if (console && console.log) {
                        console.log("La solicitud a fallado. errorStr: " + errorStr);
                    }
                    dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
                    dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: errorStr}});
                    dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: jqXHR.status}});
                });
        } else {
            dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 3}});
        }
        
        
    }
}

export function sendImagesAnimal(info, infoAccess) {
    return (dispatch) => {
        const datos_base64 = btoa(infoAccess.user + ":" + infoAccess.password);
        
        let {imagesAnimals} = info;
        // const length = imagesAnimals.length;
        //TODO 6/4/21 20:52: esto deberia ponerlo el componente de las imagenes que sabe cual está vacio y cual no
        
        // imagesAnimals = imagesAnimals.map((elem) => {
        //     return {...elem, type: "PUT"}
        // })
        
        // for (let i = 0; i < 6; i++) {
        //     if (!imagesAnimals.some((img) => img.order === i)) {
        //         imagesAnimals.push({order: i, type: "DELETE"})
        //     }
        // }
        
        // const imagesAnimalsOrdered = imagesAnimals && imagesAnimals.length > 0
        //     ? imagesAnimals.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
        //     : [];
        
        
        const promesas = imagesAnimals.filter((img) => img.isModified).map((imageData) => {
            return new Promise((resolve, reject) => {
                imageData.data = null;
                // console.log("Lanzando peticion --> " + `/api/animal/${info._id}/galeria/imagen/${imageData.order}` + " --> " + JSON.stringify({
                //     o: imageData.order,
                //     t: imageData.type
                // }))
                $.ajax({
                        type: "PUT",
                        dataType: "json",
                        processData: false,
                        cache: false,
                        crossDomain: true,
                        contentType: "application/json",
                        beforeSend: function (req) {
                            req.setRequestHeader("Authorization", "Basic " + datos_base64);
                        },
                        url: `/api/animal/${info._id}/galeria/imagen/${imageData.order}`,
                        data: JSON.stringify({imageData: imageData}),
                    })
                    .done(function (_response, _textStatus, _jqXHR) {
                        // console.log("Imagen[" + imageData.type + "] de galeria guardada correctamente")
                        // dispatch({type: STEP_WAIT_BLOCK, order: {stepWaitBlock: 201}});
                        resolve({status: 201, imgNum: imageData.order});
                    })
                    .fail(function (jqXHR, textStatus, _errorThrown) {
                        // console.log("Imagen[" + imgNum + "] de galeria tuvo un error --> " + JSON.stringify(jqXHR.responseJSON))
                        
                        let errorStr;
                        if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                            errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                            
                        } else if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.message !== undefined) {
                            errorStr = "Hubo un error inesperado al guardar la imagen del animal";
                        } else {
                            errorStr = jqXHR.responseJSON;
                        }
                        //TODO 6/4/21 13:17: meter el caso del 413: Request Too Long
                        if (jqXHR.status === 401) {
                            handleSessionExpired(dispatch, jqXHR, textStatus, _errorThrown)
                        }
                        if (jqXHR.status === 413) {
                            errorStr = 'La imagen ' + (imageData.order + 1) + ' pesa demasiado, máximo 6MB por imagen';
                        }
                        
                        errorStr = errorStr || _errorThrown;
                        
                        if (console && console.log) {
                            console.log("La solicitud a fallado. errorStr: " + errorStr);
                        }
                        
                        resolve({status: jqXHR.status, errorStr: errorStr, imgNum: imageData.order})
                    });
                
            })
        });
        
        if (promesas.length > 0) {
            
            
            Promise.all(promesas)
                .then((result) => {
                    let errorStr = result
                        .filter((elem => elem.errorStr))
                        .map((elem, index) => (elem.imgNum + 1) + " por '" + elem.errorStr + "'")
                        .join(', ')
                        .replace(/,(?!.*,)/gmi, ' y');
                    
                    if (errorStr) {
                        errorStr = "Error en la imagen: " + errorStr;
                        // console.log("Mensaje de error --> " + errorStr);
                        dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
                        dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: errorStr}});
                        dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 500}});
                        
                    } else {
                        // console.log("Sin errores en las imagenes :)");
                        dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: undefined}});
                        dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: undefined}});
                        dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
                    }
                })
                .catch((err) => {
                    // console.log("ERROR en las promesas")
                    // console.error(err)
                    const errStr = "Hubo un error inesperado :(";
                    dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errStr}});
                    dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: errStr}});
                    dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 500}});
                    
                });
        } else {
            // console.log("Sin modificar ninguna imagen");
            // dispatch({type: SHOW_WAIT_BLOCK, payload: {showWaitBlock: false}});
            dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
            dispatch({type: ERROR_INSERT_ANIMAL, payload: {errorInsertAnimal: undefined}});
            dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: undefined}});
            
        }
        
        // $.ajax({
        //     type: "PUT",
        //     dataType: "json",
        //     processData:false,
        //     cache:false,
        //     crossDomain: true,
        //     contentType: "application/json",
        //     beforeSend: function(req) {
        //         req.setRequestHeader("Authorization", "Basic " + datos_base64);
        //     },
        //     url: `/api/animal/${info._id}/galeria/imagenes`,
        //     data: JSON.stringify({ listImagesData : imagesAnimalsOrdered }),
        // })
        //     .done(function (_response, _textStatus, _jqXHR) {
        //         dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});
        //     })
        //     .fail(function (jqXHR, textStatus, _errorThrown) {
        //         let errorStr;
        //         if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
        //             errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
        //         }else{
        //             errorStr = jqXHR.responseJSON;
        //         }
        //
        //         if ( console && console.log ) {
        //             console.log( "La solicitud a fallado: " +  errorStr);
        //         }
        //         dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
        //         dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: jqXHR.status}});
        //     });
        
    }
}


function parserBasicData(data) {
    let dataReturn = {};
    Object.keys(data).forEach((val) => {
        if (val === "_id" && data[val] !== undefined) {
            dataReturn.id = data[val];
        } else if (val === "nombre" && data[val] !== undefined) {
            dataReturn.nombre = data[val];
        } else if (val === "especie" && data[val] !== undefined) {
            dataReturn.especie = data[val];
        } else if (val === "sexo" && data[val] !== undefined) {
            dataReturn.sexo = data[val];
        } else if (val === "tamano" && data[val] !== undefined && data[val].length > 0) {
            dataReturn.tamano = data[val];
        } else if (val === "edad" && data[val] !== undefined && data[val].length > 0) {
            dataReturn.edad = data[val];
        } else if (val === "raza" && data[val] !== undefined && data[val].length > 0) {
            if (data[val].findIndex(x => x === "TODAS") < 0) {
                dataReturn.raza = data[val].join(",");
            }
        } else if (val === "enfermedades" && data[val] !== undefined) {
            dataReturn.enfermedades = data[val];
        } else if (val === "caracter" && data[val] !== undefined && data[val].length > 0) {
            dataReturn.caracter = data[val].join(",");
        } else if (val === "estado" && data[val] !== undefined) {
            dataReturn.estado = data[val];
        } else if (val === "color" && data[val] !== undefined) {
            dataReturn.color = data[val].join(",");
        } else if (val === "caracter" && data[val] !== undefined) {
            dataReturn.caracter = data[val];
        } else if (val === "chip" && data[val] !== undefined) {
            dataReturn.chip = data[val];
        } else if (val === "vacunas" && data[val] !== undefined) {
            dataReturn.vacunas = data[val];
        } else if (val === "ppp" && data[val] !== undefined) {
            dataReturn.ppp = data[val];
        } else if (val === "mestizo" && data[val] !== undefined) {
            dataReturn.mestizo = data[val];
        } else if (val === "descripcion" && data[val] !== undefined) {
            dataReturn.descripcion = data[val];
        } else if (val === "esterilizado" && data[val] !== undefined) {
            dataReturn.esterilizado = data[val];
        } else if (val === "direccion" && data[val] !== undefined) {
            dataReturn.direccion = data[val];
        } else if (val === "fecha_entrada_protectora" && data[val] !== undefined) {
            dataReturn.fecha_entrada_protectora = data[val];
        } else if (val === "email_adoptante" && data[val] !== undefined) {
            dataReturn.email_adoptante = data[val];
        } else if (val === "email_acogido" && data[val] !== undefined) {
            dataReturn.email_acogido = data[val];
        }
    });
    
    return dataReturn;
}

/**
 * Convert a base64 string in a Blob according to the data and contentType.
 *
 * @param b64Data {String} Pure base64 string without contentType
 * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
 * @param sliceSize {Int} SliceSize to process the byteCharacters
 * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 * @return Blob
 */
function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        
        var byteArray = new Uint8Array(byteNumbers);
        
        byteArrays.push(byteArray);
    }
    
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
}
